import { convertParams } from 'src/utils/utils'
import axios from '../axios'
import { STICKERROUTES } from 'src/router/Api'

export const getListSticker = async (params) => {
	return await axios.get(STICKERROUTES.name, {
		params: convertParams(params),
	})
}

export const createSticker = async (body: { title: string }) => {
	return await axios.post(STICKERROUTES.name, body)
}

export const updateSticker = async (id: string, body: any) => {
	return await axios.put(`${STICKERROUTES.name}/${id}`, body)
}

export const createStickerItemsFromZip = async (
	stickerId: string,
	file: File,
) => {
	const formData = new FormData()
	formData.append('file', file)

	return await axios.post(STICKERROUTES.itemsFromZip(stickerId), formData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	})
}

export const deleteStickerItem = async (stickerId: string, itemId: string) => {
	return await axios.delete(STICKERROUTES.item(stickerId, itemId))
}
